import type { RangeOption } from "../../../constants/epicLeaderboard";
import type { ApiResource } from "../../../hooks/useApiResource";
import type { PkFeedResponse } from "../../../types/playerPk";
import SkeletonBlock from "../../common/SkeletonBlock";
import PaginationControls from "../../boards/PaginationControls";
import PkFeedRowItem from "./PkFeedRowItem";
import PkSection, { PkEmpty, PkError } from "./PkSection";

const FeedSkeleton = () => (
  <div role="status" aria-label="Loading recent PK feed">
    {Array.from({ length: 6 }).map((_, i) => (
      <SkeletonBlock key={i} height={44} className="mb-2" />
    ))}
  </div>
);

type Props = {
  player: string;
  feed: ApiResource<PkFeedResponse>;
  range: RangeOption;
  onPageChange: (page: number) => void;
};

const RecentFeed = ({ player, feed, range, onPageChange }: Props) => {
  const { data, loading, error, reload } = feed;

  let body;
  if (data) {
    body =
      data.rows.length === 0 ? (
        <PkEmpty>No PK activity in this range.</PkEmpty>
      ) : (
        <>
          <div className="pk-card">
            {data.rows.map((row) => (
              <PkFeedRowItem
                key={row.id}
                row={row}
                range={range}
                viewer={player}
              />
            ))}
          </div>
          {data.pagination.totalPages > 1 && (
            <div className="pk-feed-pagination">
              <PaginationControls
                pagination={data.pagination}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </>
      );
  } else if (error) {
    body = <PkError what="the PK feed" error={error} onRetry={reload} />;
  } else {
    body = <FeedSkeleton />;
  }

  return (
    <PkSection
      id="pk-feed"
      title="RECENT PK FEED"
      refetching={loading && !!data}
    >
      {body}
    </PkSection>
  );
};

export default RecentFeed;
